import chroma from 'chroma-js';
import geojsonData from '~/assets/data/reiseziele.geo.json';

export const steps = ARTICLE_CONFIG.steps;

geojsonData.features = geojsonData.features.map(feat => {
  steps.forEach(s => {
    if (feat.properties[s] !== null && !isNaN(+feat.properties[s])) {
      feat.properties[s] = +feat.properties[s];
    }
  });
  return feat;
});

export const geojson = geojsonData;

export const data = geojson.features
  .filter(feat => feat.properties['iso-code'])
  .map(feat => feat.properties)
  .reduce((res, item) => {
    if (!res.find(d => d.ISO3_CODE === item.ISO3_CODE)) {
      res.push(item);
    }
    return res;
  }, []);

export const colorScale = [
  [0, '#eeeeee'],
  [0.1, '#FFF1BB'],
  [1, '#FFDD9E'],
  [4, '#FCC08E'],
  [7, '#EE9F82'],
  [11, '#D97C7A'],
  [17, '#BE5672'],
  [30, '#A1286A'],
  [50]
];

export const noDataColor = chroma('#D5E4F1');

export function getCurrentScale(value) {
  return colorScale.reduce((res, item, index, items) => {
    if (index > 0) {
      if (value >= items[index - 1][0] && value < items[index][0]) {
        res = index - 1;
      }
    }

    return res;
  }, 0);
}